import React from "react";
import { Pill, Reveal } from "./Reveal";

const COMMITMENTS = [
  ["Reads first.", "Nothing changes until a person approves it."],
  [
    "Built on your way of working.",
    "Your checklist, your naming, your review order.",
  ],
  [
    "Yours.",
    "Your accounts hold it, your log records it, and it runs without us.",
  ],
];

// What the client ends up with, then the three things that are true of every tool we build.
export default function Commitments() {
  return (
    <section
      id="commitments"
      className="scroll-mt-10 bg-white px-5 py-24 lg:py-36"
      data-testid="commitments"
    >
      <div className="mx-auto max-w-[1400px]">
        <Pill>What you end up with</Pill>
        <Reveal className="mt-6">
          <h2 className="nm-title max-w-[1100px] text-[36px] leading-[1.02] sm:text-[64px] lg:text-[76px]">
            One job that runs the same way every week. A tool you own. A team
            that approves instead of assembling.
          </h2>
          <p className="mt-8 max-w-[560px] text-[20px] leading-[1.3] tracking-[-0.015em] opacity-60 sm:text-[24px]">
            We build it, hand it over, and leave.
          </p>
        </Reveal>
        <div className="mt-14 grid gap-3 md:grid-cols-3 lg:mt-20">
          {COMMITMENTS.map(([head, text], i) => (
            <Reveal key={head} delay={i * 110}>
              <div className="flex h-full min-h-[230px] flex-col justify-between rounded-[28px] bg-[#f7f7f7] p-7 sm:p-9">
                <span className="text-[12px] tabular-nums opacity-40">
                  0{i + 1}
                </span>
                <div>
                  <p className="nm-title text-[28px] leading-[1.05] sm:text-[34px]">
                    {head}
                  </p>
                  <p className="mt-3 text-[17px] leading-[1.35] opacity-60">
                    {text}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
